import React from "react";

import Button from "Common/Button";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("DesktopCloseButton");

type Props = React.ElementProps<typeof Button>;

export const DesktopCloseButton = ({ onHide, ...rest }: Props) => (
  <button type="button" className={bem()} aria-label="Close" onClick={onHide} {...rest}>
    <span aria-hidden="true">
      <Icon size="3x" icon="times" className={bem("Icon")} flavor="solid" />
    </span>
  </button>
);
